module.exports = __webpack_public_path__ + "images/gameBuildIcon-d20f165b3edbe47ae6351c56b7f9b1d3.svg";